const REPORTS_MIDDLEWARES = {
  auth: null,
  permission: 'REPORTS',
};

export default {
  path: '/reports',
  name: 'r_reports',
  meta: {
    middlewares: REPORTS_MIDDLEWARES,
  },
  component: () => import('../../components/reports/Reports'),
  children: [
    {
      path: 'reservations',
      name: 'r_reports-reservations',
      meta: {
        middlewares: REPORTS_MIDDLEWARES,
      },
      props: {
        backLinkName: 'r_reports',
        slug: 'reports',
      },
      component: () => import('../../components/reports/reservations/Reservations'),
      children: [
        {
          path: 'dashboard',
          name: 'r_reports-reservations-dashboard',
          meta: {
            middlewares: REPORTS_MIDDLEWARES,
          },
          props: {
            backLinkName: 'r_reports-reservations',
          },
          component: () => import('../../components/reports/reservations/Dashboard'),
          children: [
            {
              path: 'map',
              name: 'r_reports-reservations-dashboard-map',
              meta: {
                middlewares: REPORTS_MIDDLEWARES,
              },
              props: {
                backLinkName: 'r_reports-reservations-dashboard',
              },
              component: () => import('../../components/reports/reservations/Map'),
            },
            {
              path: 'search-filters',
              name: 'r_reports-reservations-dashboard-search-filters',
              meta: {
                middlewares: REPORTS_MIDDLEWARES,
              },
              props: {
                backLinkName: 'r_reports-reservations-dashboard',
                savePresetLinkName: 'r_reports-reservations-dashboard-search-filters-save-preset',
              },
              component: () => import('../../components/search/SearchFilters'),
              children: [
                {
                  path: 'save-preset',
                  name: 'r_reports-reservations-dashboard-search-filters-save-preset',
                  meta: {
                    middlewares: REPORTS_MIDDLEWARES,
                  },
                  props: {
                    backLinkName: 'r_reports-reservations-dashboard-search-filters',
                  },
                  component: () => import('../../components/search/SearchFiltersPresets'),
                },
              ],
            },
          ],
        },
        {
          path: 'min-average-max',
          name: 'r_reports-reservations-min-average-max',
          meta: {
            middlewares: REPORTS_MIDDLEWARES,
          },
          props: {
            backLinkName: 'r_reports-reservations',
          },
          component: () => import('../../components/reports/reservations/MinAverageMax'),
          children: [
            {
              path: 'map',
              name: 'r_reports-reservations-min-average-max-map',
              meta: {
                middlewares: REPORTS_MIDDLEWARES,
              },
              props: {
                backLinkName: 'r_reports-reservations-min-average-max',
                slug: 'reports-reservations-min-average-max',
              },
              component: () => import('../../components/reports/reservations/Map'),
            },
            {
              path: 'search-filters',
              name: 'r_reports-reservations-min-average-max-search-filters',
              meta: {
                middlewares: REPORTS_MIDDLEWARES,
              },
              props: {
                backLinkName: 'r_reports-reservations-min-average-max',
                savePresetLinkName:
                  'r_reports-reservations-min-average-max-search-filters-save-preset',
              },
              component: () => import('../../components/search/SearchFilters'),
              children: [
                {
                  path: 'save-preset',
                  name: 'r_reports-reservations-min-average-max-search-filters-save-preset',
                  meta: {
                    middlewares: REPORTS_MIDDLEWARES,
                  },
                  props: {
                    backLinkName: 'r_reports-reservations-min-average-max-search-filters',
                  },
                  component: () => import('../../components/search/SearchFiltersPresets'),
                },
              ],
            },
          ],
        },
        {
          path: 'historical-occupancy',
          name: 'r_reports-reservations-historical-occupancy',
          meta: {
            middlewares: REPORTS_MIDDLEWARES,
          },
          props: {
            backLinkName: 'r_reports-reservations',
          },
          component: () => import('../../components/reports/reservations/HistoricalOccupancy'),
          children: [
            {
              path: 'map',
              name: 'r_reports-reservations-historical-occupancy-map',
              meta: {
                middlewares: REPORTS_MIDDLEWARES,
              },
              props: {
                backLinkName: 'r_reports-reservations-historical-occupancy',
                slug: 'reports-reservations-historical-occupancy',
              },
              component: () => import('../../components/reports/reservations/Map'),
            },
            {
              path: 'search-filters',
              name: 'r_reports-reservations-historical-occupancy-search-filters',
              meta: {
                middlewares: REPORTS_MIDDLEWARES,
              },
              props: {
                backLinkName: 'r_reports-reservations-historical-occupancy',
                savePresetLinkName:
                  'r_reports-reservations-historical-occupancy-search-filters-save-preset',
              },
              component: () => import('../../components/search/SearchFilters'),
              children: [
                {
                  path: 'save-preset',
                  name: 'r_reports-reservations-historical-occupancy-search-filters-save-preset',
                  meta: {
                    middlewares: REPORTS_MIDDLEWARES,
                  },
                  props: {
                    backLinkName: 'r_reports-reservations-historical-occupancy-search-filters',
                  },
                  component: () => import('../../components/search/SearchFiltersPresets'),
                },
              ],
            },
          ],
        },
        {
          path: 'prediction-daily',
          name: 'r_reports-reservations-prediction-daily',
          meta: {
            middlewares: REPORTS_MIDDLEWARES,
          },
          props: {
            backLinkName: 'r_reports-reservations',
          },
          component: () => import('../../components/reports/reservations/PredictionDaily'),
          children: [
            {
              path: 'map',
              name: 'r_reports-reservations-prediction-daily-map',
              meta: {
                middlewares: REPORTS_MIDDLEWARES,
              },
              props: {
                backLinkName: 'r_reports-reservations-prediction-daily',
                slug: 'reports-reservations-prediction-daily',
              },
              component: () => import('../../components/reports/reservations/Map'),
            },
            {
              path: 'search-filters',
              name: 'r_reports-reservations-prediction-daily-search-filters',
              meta: {
                middlewares: REPORTS_MIDDLEWARES,
              },
              props: {
                backLinkName: 'r_reports-reservations-prediction-daily',
                savePresetLinkName:
                  'r_reports-reservations-prediction-daily-search-filters-save-preset',
              },
              component: () => import('../../components/search/SearchFilters'),
              children: [
                {
                  path: 'save-preset',
                  name: 'r_reports-reservations-prediction-daily-search-filters-save-preset',
                  meta: {
                    middlewares: REPORTS_MIDDLEWARES,
                  },
                  props: {
                    backLinkName: 'r_reports-reservations-prediction-daily-search-filters',
                  },
                  component: () => import('../../components/search/SearchFiltersPresets'),
                },
              ],
            },
          ],
        },
        {
          path: 'prediction-weekday',
          name: 'r_reports-reservations-prediction-weekday',
          meta: {
            middlewares: REPORTS_MIDDLEWARES,
          },
          props: {
            backLinkName: 'r_reports-reservations',
          },
          component: () => import('../../components/reports/reservations/PredictionWeekday'),
          children: [
            {
              path: 'map',
              name: 'r_reports-reservations-prediction-weekday-map',
              meta: {
                middlewares: REPORTS_MIDDLEWARES,
              },
              props: {
                backLinkName: 'r_reports-reservations-prediction-weekday',
                slug: 'reports-reservations-prediction-weekday',
              },
              component: () => import('../../components/reports/reservations/Map'),
            },
            {
              path: 'search-filters',
              name: 'r_reports-reservations-prediction-weekday-search-filters',
              meta: {
                middlewares: REPORTS_MIDDLEWARES,
              },
              props: {
                backLinkName: 'r_reports-reservations-prediction-weekday',
                savePresetLinkName:
                  'r_reports-reservations-prediction-weekday-search-filters-save-preset',
              },
              component: () => import('../../components/search/SearchFilters'),
              children: [
                {
                  path: 'save-preset',
                  name: 'r_reports-reservations-prediction-weekday-search-filters-save-preset',
                  meta: {
                    middlewares: REPORTS_MIDDLEWARES,
                  },
                  props: {
                    backLinkName: 'r_reports-reservations-prediction-weekday-search-filters',
                  },
                  component: () => import('../../components/search/SearchFiltersPresets'),
                },
              ],
            },
          ],
        },
        {
          path: 'technical-list',
          name: 'r_reports-reservations-technical-list',
          meta: {
            middlewares: REPORTS_MIDDLEWARES,
          },
          props: {
            backLinkName: 'r_reports-reservations',
          },
          component: () => import('../../components/reports/reservations/TechnicalList'),
          children: [
            {
              path: 'map',
              name: 'r_reports-reservations-technical-list-map',
              meta: {
                middlewares: REPORTS_MIDDLEWARES,
              },
              props: {
                backLinkName: 'r_reports-reservations-technical-list',
                slug: 'reports-reservations-technical-list',
              },
              component: () => import('../../components/reports/reservations/Map'),
            },
            {
              path: 'search-filters',
              name: 'r_reports-reservations-technical-list-search-filters',
              meta: {
                middlewares: REPORTS_MIDDLEWARES,
              },
              props: {
                backLinkName: 'r_reports-reservations-technical-list',
                savePresetLinkName:
                  'r_reports-reservations-technical-list-search-filters-save-preset',
              },
              component: () => import('../../components/search/SearchFilters'),
              children: [
                {
                  path: 'save-preset',
                  name: 'r_reports-reservations-technical-list-search-filters-save-preset',
                  meta: {
                    middlewares: REPORTS_MIDDLEWARES,
                  },
                  props: {
                    backLinkName: 'r_reports-reservations-technical-list-search-filters',
                  },
                  component: () => import('../../components/search/SearchFiltersPresets'),
                },
              ],
            },
          ],
        },
      ],
    },
    {
      path: ':report',
      name: 'r_report',
      meta: {
        middlewares: {
          auth: null,
          permission: 'REPORTS',
        },
      },
      props: { backLinkName: 'r_reports' },
      component: () => import('../../components/reports/Report'),
      children: [
        {
          path: 'auto-release',
          name: 'r_report-auto-release',
          meta: {
            middlewares: {
              auth: null,
              permission: 'REPORTS',
            },
          },
          props: { backLinkName: 'r_report' },
          component: () => import('../../components/reports/AutoRelease'),
          children: [
            {
              path: 'search-filters',
              name: 'r_report-auto-release-search-filters',
              meta: {
                middlewares: {
                  auth: null,
                  permission: 'REPORTS',
                },
              },
              props: {
                backLinkName: 'r_report-auto-release',
              },
              component: () => import('../../components/search/SearchFilters'),
            },
          ],
        },
      ],
    },
  ],
};
